import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const bankListUpload = (uploadFile) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/master/bank-bulk-upload",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};

export const CAUserListUpload = (uploadFile) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/master/causer-bulk-upload",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};

export const companyListUpload = (uploadFile) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/master/company-bulk-upload",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};

export const bankerListUpload = (uploadFile) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/master/banker-bulk-upload",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};

export const LeadListUpload = (uploadFile, leadSourceUpload) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload
    formData.append("leadSource", leadSourceUpload); // Assuming 'file' is the file object you want to upload

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/lead-bulk-upload",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};


export const LeadDocumentUpload = (uploadFile, leadId, description) => {
    const formData = new FormData();
    formData.append("fileData", uploadFile); // Assuming 'file' is the file object you want to upload
    formData.append("documentType", "img");
    formData.append("uploadBy", leadId);
    formData.append("description", description); 

    return axios({
        method: "post",
        url:
            BASE_URL + "/fseva-lead/api/secure/v1/lead/" + leadId + "/document",
        data: formData,
        headers: getHeaders("multipart/form-data"),
    });
};
